import React from 'react'
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import Dashboard from '../Pages/Dashboard/Dashboard'
import Login from '../Pages/Login/login'
import Navbar from '../Components/Navbar/Navbar'
import DashboardLayout from '../Components/Dashboard/DashboardLayboard'
import AirportMaster from '../Components/AirportMaster/AirportMaster'
import AirlineMaster from '../Components/AirlineMaster/AirlineMaster'
import UserMaster from '../Components/User/UserMaster'

const AppRouter = (props) => {
  const { } = props
  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

    return (
      <>
        <BrowserRouter>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route path='/' element={<Navigate to="/airportmaster" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/navbar" element={<Navbar />} />
              <Route path="/airportmaster" element= {<AirportMaster/>}/>
              <Route path="/airlinemaster" element= {<AirlineMaster/>}/>
              <Route path="/usermaster" element= {<UserMaster/>}/>
            </Route>
          </Routes>
        </BrowserRouter>
      </>
    )
  }

export default AppRouter